import Axios from "axios";
import dotenv from "dotenv";

dotenv.config();

export const axios = () => {
  return Axios.create({
    baseURL: process.env.REACT_APP_REQUEST_ENDPOINT,
  });
};

export const authAxios = () => {
  const token = localStorage.getItem("token");

  return Axios.create({
    baseURL: process.env.REACT_APP_REQUEST_ENDPOINT,
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};

export const basicAuth = () => {
  // const token = `${applore_con}:${"password"}`;
  // const encodedToken = Buffer.from(token).toString("base64");
  // console.log("ft", encodedToken);
  return Axios.create({
    baseURL: process.env.REACT_APP_REQUEST_ENDPOINT,
    headers: {
      Authorization:
        "Basic " +
        Buffer.from(
          process.env.REACT_APP_SAP_USERNAME +
            ":" +
            process.env.REACT_APP_SAP_PASSWORD
        ).toString("base64"),
    },
  });
};

export default authAxios;
